import { observer } from 'mobx-react';
import * as React from 'react';

import { BaseModalProps } from 'shared/newEntities/components/modals';
import FormModal from 'shared/newComponents/modals/FormModal';
import { ComponentType } from 'shared/entities/components/Component';
import { useProjectsStore, useRouterStore } from 'stores/index';
import { ProjectEditModel } from 'shared/models/project';
import { urls } from 'shared/entities/domain';
import { Input } from 'shared/newComponents/form';
import { LoadingStage } from 'shared/entities/meta';

type Props = BaseModalProps;

const CreateProjectModal: React.FC<Props> = (props) => {
  const projectsStore = useProjectsStore();
  const routerStore = useRouterStore();
  const projectEditModel = React.useRef<ProjectEditModel>(
    ProjectEditModel.fromDefaultParams()
  ).current;

  const title = projectEditModel.name;

  const handleCreate = async (): Promise<void> => {
    const response = await projectsStore.create({
      projectEditModel
    });

    if (!response.isError) {
      props.onClose();
      routerStore.push(
        urls.PROJECT.tabs.ONBOARDING.create({
          projectId: response.data.id
        })
      );
    }
  };

  return (
    <FormModal
      title={(t) =>
        t('CreateProjectModal.title', {
          ns: 'newContainers'
        })
      }
      ok={{
        type: ComponentType.button,
        isLoading: projectsStore.creatingStage === LoadingStage.LOADING,
        children: (t) =>
          t('CreateProjectModal.create', {
            ns: 'newContainers'
          }),
        onClick: handleCreate
      }}
      onEnter={handleCreate}
      {...props}
    >
      <Input
        label={(t) =>
          t('CreateProjectModal.input.label', {
            ns: 'newContainers'
          })
        }
        placeholder={(t) =>
          t('CreateProjectModal.input.placeholder', {
            ns: 'newContainers'
          })
        }
        onBlur={title.validate}
        value={title.value}
        onChange={title.changeValue}
        error={title.error}
      />
    </FormModal>
  );
};

export default observer(CreateProjectModal);
